var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M36.7872 101.913L12.5152 12.4969L102.087 36.1846L36.7872 101.913Z",
    stroke: "#F3A023",
    strokeWidth: 17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTriangle);
export default __webpack_public_path__ + "static/media/orangeTriangle.36ef43a44bd082fc8f449cc55b91a4f8.svg";
export { ForwardRef as ReactComponent };